import React, { useState, useEffect, useContext,useRef } from "react";
import Table from 'components/Table/Table';
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import VerticalLinearStepper from "views/Dashboard/SignatureUnEnrollments/Stepper/VerticalStepper";
import HorizontalStepperForUnenrollment from "views/Dashboard/SignatureUnEnrollments/Stepper/HorizontalStepper";
import CloseIcon from '@material-ui/icons/Close';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import ThriveSignatureRequests from 'apis/ThriveSignatureRequest/ThriveSignatureRequest';
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import context from "context/context";
import Loader from "components/Loader/Loader";
import useDebounce from 'helpers/useDebounce';
import Card from '@material-ui/core/Card';
import { toast } from 'react-toastify';
import {
    Tabs,
    Tab,
    Box,
    withStyles,
    TextField,
    IconButton,
    Dialog,
    InputAdornment,
    Button,
    Badge,
    DialogContent,
    DialogContentText,
    Grid,
    MenuItem
} from "@material-ui/core";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { Styles } from "./styles";
import searchIcon from "assets/img/Search_Icon.png";
import {
    DatePicker,
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { enUS, fr } from "date-fns/locale";
import { useTranslation } from 'react-i18next';
import { setDate } from "date-fns";
import { CSVLink } from "react-csv";
import { exportHeaders } from './export';

// custom TextField
const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '##D3D3D3',
        },
        '& .MuiFormLabel-root': {
            color: '#707070',
        },
        '& .MuiInputBase-input': {
            color: '#707070',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#707070!important',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#707070!important',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#707070',
            },
            '&:hover fieldset': {
                borderColor: '#707070',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#707070',
            },
            '&.MuiOutlinedInput-root': {
                borderRadius: 20,
            },
            '&.MuiOutlinedInput-root': {
                marginTop: 0,
                borderRadius: 20,
                background: '#ededed',
            },
        },
    },
})(TextField);

function AllRequests({ readOnlyDialogObj, setReadOnlyDialogObj, setCreateDialogObj, team }) {
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [resLoaded, setResLoaded] = useState(false);
    const { t, i18n } = useTranslation();
    const { getsignatureUnenrollment, unenrollmentsearchAPI, unenrollmentFilter, unenrollmentExport } = ThriveSignatureRequests();
    const { dispatch, state } = useContext(context);
    const [fitervalue, setfiterValue] = useState("");
    const [open, setOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [filterCard, setFilterCard] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [exportData, setExportData] = useState([]);
    const [logData, setLogData] = useState([]);
    const [response, setResponse] = useState({
        filter: false,
    });
    const classes = Styles();
    const [states, setStates] = useState({
        historyLoader: false,
        clearSearch: false,
        status: "",
        plan: "",
        filter: false
    });

    const searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    useEffect(() => {
        // Optional: update pathname globally
        // dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'RESPONSE'] });
        handleGet();
    }, []);

    useEffect(() => {
        if (states?.clearSearch) {
            setStates((prev) => ({ ...prev, clearSearch: false }));
            return;
        }

        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        } else if (states?.filter) {
            handleFilter();
        } else {
            handleGet();
        }
    }, [searchBounceValues, offset, states?.filter]);


    const handlePagination = (value) => {
        setOffset(value);
    };

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            const res = await getsignatureUnenrollment(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10
            };
            const res = await unenrollmentsearchAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            setLoading(false);
        }
    };

    const getPlanName = (plan) => {
        if (!plan) return "-";
        if (plan == 'ST0') return "Monthly";
        if (plan == "ST1") return "Yearly";
        if (plan == "ST2") return "Trial";
        if (plan == "Unlocked") return "Unlocked";
        return "-";
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleFilter = async () => {
        try {
            if (!states.status && !states.plan) return;

            const values = {
                offset: (offset - 1) * 10,
                limit: 10,
                ...(states.status && { status: states.status }),
                ...(states.plan && { plan: states.plan }),
            };

            dispatch({ type: 'SET_LOADING', payload: true });
            const res = await unenrollmentFilter(values);

            if (res) {
                setData(res.data);
                setCount(res.count);
                setFilterCard(false);
                dispatch({ type: 'SET_LOADING', payload: false });
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleExport = async () => {
        try {
            let values = {};


            // Priority 1: Search-based export
            if (searchValue) {
                values = { ...values, search: searchValue };
            }
            // Priority 2: Filter-based export
            if (states.status || states.plan) {
                values = {
                    ...values,
                    ...(states.status && { status: states.status }),
                    ...(states.plan && { plan: states.plan }),

                };
            }

            dispatch({ type: "SET_LOADING", payload: true });
            setIsLoading(true);
            let res = await unenrollmentExport(values);
            if (res && res.data) {
                const formattedData = res.data.map(item => {
                    const formattedItem = {};

                    Object.keys(item).forEach(key => {
                        let value = item[key];

                        // Format date specifically if key matches
                        if (key === 'hsd_sync_date') {
                            formattedItem[key] = value
                                ? moment(value).format('YYYY-MM-DD')
                                : "-";
                        } else {
                            formattedItem[key] =
                                value === null || value === undefined || value === ''
                                    ? null
                                    : value;
                        }
                    });

                    return formattedItem;
                });

                setExportData(formattedData);
                dispatch({ type: "SET_LOADING", payload: false });
                setIsLoading(false);

                if (formattedData.length === 0) {
                    toast.success(t("No Data Found"), { toastId: "no-report-date" });
                    return false;
                }

                return true;
            }
        } catch (e) {
            console.log(e);
            dispatch({ type: "SET_LOADING", payload: false });
        }
    };
    //     if (res && res.data) {
    //         setExportData(res.data);
    //         dispatch({ type: "SET_LOADING", payload: false });
    //         setIsLoading(false);
    //         if (res.data.length === 0) {
    //             toast.success(t("No Data Found"), { toastId: "no-report-date" });
    //             return false;
    //         }
    //         return true;
    //     }
    // } catch (e) {
    //     console.log(e);
    //     dispatch({ type: "SET_LOADING", payload: false });
    // }
    // };

    return (
        <>
            <CssTextField
                id="enterPassword"
                placeholder={'Search for Shipto'}
                onKeyDown={blockInvalidChar}
                type={"number"}
              onWheel={(e) => e.target.blur()}
                variant="outlined"
                autoComplete="off"
                className={classes.searchInput}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {searchValue.length > 0 ? (
                                <CloseOutlinedIcon
                                    className={classes.searchInputIcon}
                                    onClick={() => {
                                        setSearchValue("");
                                        setOffset(1);
                                        handleGet();
                                    }}
                                />
                            ) : (
                                <img
                                    src={searchIcon}
                                    alt=""
                                    width="20px"
                                    className={classes.searchInputIcon}
                                />
                            )}
                        </InputAdornment>
                    ),
                }}
                value={searchValue}
                onChange={(e) => {
                    e.target.value.replace(/\s+/g, "").length == 0
                        ? setSearchValue("")
                        : setSearchValue(e.target.value);
                    if (e.target.value.length == 0) {
                        handleGet();
                    }
                }}
                onClick={() => {
                    setOffset(1);
                }}
            />
            <Button
                className={`${classes.filterBtn} dash-1-filter-btn`}
                onClick={() => {
                    setFilterCard(!filterCard);
                }}
                onChange={(e) => {
                    setfiterValue(e.target.value);
                }}
            >
                Filter
                {response["filter"] && (
                    <Badge
                        badgeContent={count == 0 ? null : response["filter"] && count}
                        color="error"
                        classes={{ badge: classes.badge }}
                        max={999999}
                        className={classes.badges}
                    ></Badge>
                )}
            </Button>
            {(state?.userInfo?.role_id === 3 || state?.userInfo?.role_id === 13 || state?.userInfo?.role_id === 10) && (
                <Button
                    className={`${classes.filterBtn} dash-1-filter-btn`}
                    onClick={() => setCreateDialogObj({ open: true })}
                >
                    Create New Unenrollment Request
                </Button>
            )}
            <CSVLink
                id="csv"
                data={exportData.map(item => ({
                    ...item
                }))}

                headers={exportHeaders}
                filename={
                    `Unenrollments` +
                    " " +
                    moment(new Date()).format("MM-DD-YYYY,h:mm A") +
                    ".csv"
                }
                className={classes.CSVlink}
            />
            <Button
                disabled={isLoading}
                className={`${classes.filterBtn} dash-1-filter-btn`}
                onClick={async () => {
                    let res = await handleExport();
                    if (res) {
                        document.getElementById("csv").click();
                    }
                }}
            >{isLoading ? (
                <div class="snippet" style={{ marginLeft: 25 }}>
                    <div class="stage">
                        <div class="dot-typing-e"></div>
                    </div>
                </div>
            ) :
                t('Export')
                }
            </Button>
            {filterCard && (
                <div className={classes.filterCardDiv}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} style={{ float: 'right' }}>
                            <Card className={classes.filterCard}>
                                <Grid
                                    container
                                    spacing={1}
                                    className={classes.filterCardGridContainer}
                                >
                                    {/* Status */}
                                    <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        className={classes.filterCardGrid}
                                        style={{ padding: '5px 10px 10px 15px' }}
                                    >
                                        <TextField
                                            id="Status"
                                            label={t('Status')}
                                            select
                                            fullWidth
                                            type="text"
                                            value={states?.status}
                                            onChange={(e) => {
                                                setStates({
                                                    ...states, // keep previous values
                                                    status: e.target.value,
                                                });
                                            }}
                                        >
                                            <MenuItem value="Inprogress">{t('Inprogress')}</MenuItem>
                                            <MenuItem value="Processed">{t('Processed')}</MenuItem>
                                            <MenuItem value="Cancelled">{t('Cancelled')}</MenuItem>
                                        </TextField>
                                    </Grid>

                                    {/* Plan */}
                                    <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        className={classes.filterCardGrid}
                                        style={{ padding: '5px 10px 10px 10px' }}
                                    >
                                        <TextField
                                            id="Plan"
                                            label={t('Plan')}
                                            select
                                            fullWidth
                                            type="text"
                                            value={states?.plan}
                                            onChange={(e) => {
                                                setStates({
                                                    ...states, // keep previous values
                                                    plan: e.target.value,
                                                });
                                            }}
                                        >
                                            <MenuItem value="ST1">{t('Yearly')}</MenuItem>
                                            <MenuItem value="ST0">{t('Monthly')}</MenuItem>
                                            <MenuItem value="ST2">{t('Trial')}</MenuItem>
                                            <MenuItem value="Unlocked">{t('Unlocked')}</MenuItem>
                                        </TextField>
                                    </Grid>

                                    {/* Buttons */}
                                    <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        className={classes.filterCardBtnGrid}
                                        style={{ padding: 10, display: "flex", justifyContent: "space-between" }}
                                    >
                                        <Button
                                            className={classes.filterCardApplyBtn}
                                            style={{
                                                fontSize: 15,
                                                //   height: 35,
                                                marginTop: 0,
                                            }}
                                            onClick={() => {
                                                if (!states.status && !states.plan) {
                                                    toast.error('Please select any one of the fields', {
                                                        toastId: 'filter-empty',
                                                    });
                                                    return;
                                                }
                                                setSearchValue('');
                                                setStates((prev) => ({
                                                    ...prev,
                                                    filter: true,
                                                }));
                                                setOffset(1);
                                                setCount(0);
                                                handleFilter();
                                            }}
                                        >
                                            {t('Apply')}
                                        </Button>

                                        {states.filter && (
                                            <Button
                                                className={classes.filterCardResetBtn}
                                                onClick={() => {
                                                    setStates({
                                                        filter: false,
                                                        status: '',
                                                        plan: '',
                                                    });
                                                    setFilterCard(false);
                                                    if (offset === 1) {
                                                        handleGet();
                                                    } else {
                                                        setOffset(1);
                                                    }
                                                }}
                                            >
                                                {t('Reset')}
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            )}
            <Loader loading={state?.loading} top='15%'>
                <Grid className={classes.tableDownInResponsive}>
                    <Grid item xs={12}>
                        {loading ? (
                            <div
                                style={{
                                    height: "25vh",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <h2>{t('Loading...')}</h2>
                            </div>
                        ) : (
                            < Table
                                headings={['Shipto', 'Account Name', 'City', 'Plan', 'Segment', 'Request Date', 'Status', 'HSD Date Sync', 'View']}
                                data={
                                    data?.map((d, i) => [
                                        d?.shipto,
                                        d?.account_name,
                                        d?.city,
                                        // d?.email,
                                        <span>{getPlanName(d?.privilege_code)}</span>,
                                        d?.segment_code || '-',
                                        moment(d?.request_date).format('MM-DD-YYYY'),
                                        <div
                                        style={{
                                            color:
                                                d?.status === 'Inprogress'
                                                    ? 'orange'
                                                    : d?.status === 'Cancelled'
                                                        ? 'red'
                                                        : 'green',
                                        }}
                                    >
                                        {d?.status}
                                    </div>,
                                        d?.hsd_sync_date || '-',
                                        <VisibilityOutlinedIcon
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                        const plan = getPlanName(d?.privilege_code);
                                        setReadOnlyDialogObj({
                                            open: true,
                                            obj: {
                                            activeStep: d?.current_step,
                                            requestId: d?.id,
                                            shipto: d?.shipto,
                                            planType: plan
                                            },
                                            index: null
                                        });
                                        }}
                                        />
                                    ])
                                }
                                offset={offset}
                                count={
                                    (count / 10) % 1 == 0
                                        ? Math.floor(count / 10)
                                        : Math.floor(count / 10 + 1)
                                }
                                handlePagination={handlePagination}
                            />
                        )}
                    </Grid>
                </Grid>
            </Loader>
        </>
    )
}

function PendingRequests({ dialogObj, setDialogObj }) {
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [fitervalue, setfiterValue] = useState("");
    const [response, setResponse] = useState({
        filter: false,
    });
    const [filterCard, setFilterCard] = useState(false);
    const classes = Styles();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [resLoaded, setResLoaded] = useState(false);
    const { t, i18n } = useTranslation();

    const { getPendingUnenrollment, searchPendingUnenrollment, getLogs, filter } = ThriveSignatureRequests();
    const { dispatch, state } = useContext(context);
    const [open, setOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [logData, setLogData] = useState([]);

    // Table Pagination Func
    const handlePagination = (value) => {
        setOffset(value);
    };


    const [states, setStates] = useState({
        historyLoader: false,
        clearSearch: false,
        status: "",
        plan: "",
        filter: false
    });

    const searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    useEffect(() => {
        // Optional: update pathname globally
        // dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'RESPONSE'] });
        handleGet();
    }, []);

    useEffect(() => {
        if (states?.clearSearch) {
            setStates((prev) => ({ ...prev, clearSearch: false }));
            return;
        }

        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        } else {
            handleGet();
        }
    }, [searchBounceValues, offset, states?.filter]);

    const getPlanName = (plan) => {
        if (!plan) return "-";
        if (plan == 'ST0') return "Monthly";
        if (plan == "ST1") return "Yearly";
        if (plan == "ST2") return "Trial";
        if (plan == "Unlocked") return "Unlocked";
        return "-"
    }

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            const res = await getPendingUnenrollment(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10
            };
            const res = await searchPendingUnenrollment(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <CssTextField
                id="enterPassword"
                placeholder={'Search for Shipto'}
                onKeyDown={blockInvalidChar}
                type={"number"}
              onWheel={(e) => e.target.blur()}
                variant="outlined"
                autoComplete="off"
                className={classes.searchInput}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {searchValue.length > 0 ? (
                                <CloseOutlinedIcon
                                    className={classes.searchInputIcon}
                                    onClick={() => {
                                        setSearchValue("");
                                        setOffset(1);
                                        handleGet()
                                    }}
                                />
                            ) : (
                                <img
                                    src={searchIcon}
                                    alt=""
                                    width="20px"
                                    className={classes.searchInputIcon}
                                />
                            )}
                        </InputAdornment>
                    ),
                }}
                value={searchValue}
                onChange={(e) => {
                    e.target.value.replace(/\s+/g, "").length == 0
                        ? setSearchValue("")
                        : setSearchValue(e.target.value);
                    if (e.target.value.length == 0) {
                        handleGet()
                    }
                }}
                onClick={() => {
                    setOffset(1);
                }}
            />
            <Loader loading={state?.loading} top='15%'>
                <Grid className={classes.tableDownInResponsive}>
                    <Grid item xs={12}>
                        {loading ? (
                            <div
                                style={{
                                    height: "25vh",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <h2>{t('Loading...')}</h2>
                            </div>
                        ) : (
                            <Table
                                headings={['Shipto', 'Account Name', 'City', 'Plan', 'Segment', 'Request Date','status' ,'View']}
                                data={
                                    data?.map((d, i) => [
                                        d?.shipto,
                                        d?.account_name,
                                        d?.city,
                                        // d?.email,
                                        <span>{getPlanName(d?.privilege_code)}</span>,
                                        d?.segment_code || '-',
                                        moment(d?.request_date).format('MM-DD-YYYY'),
                                        <div style={d?.status == "Inprogress" ? { color: 'orange' } : { color: 'green' }}>{d?.status}</div>,
                                        <VisibilityOutlinedIcon
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setDialogObj({ open: true, obj: { activeStep: d?.current_step - 1, requestId: d?.id, shipto: d?.shipto, handleGet ,plan: getPlanName(d?.privilege_code)}, index: null })}
                                        />
                                    ])
                                }
                                offset={offset}
                                count={
                                    (count / 10) % 1 == 0
                                        ? Math.floor(count / 10)
                                        : Math.floor(count / 10 + 1)
                                }
                                handlePagination={handlePagination}
                            />
                        )}
                    </Grid>
                </Grid>
            </Loader>
        </>
    )
}

function BillingRequests({ dialogObj, setDialogObj }) {
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [fitervalue, setfiterValue] = useState("");
    const [response, setResponse] = useState({
        filter: false,
    });
    const [filterCard, setFilterCard] = useState(false);
    const classes = Styles();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [resLoaded, setResLoaded] = useState(false);
    const { t, i18n } = useTranslation();

    const { getbillingunenrollmentrecord,
    billingdateunenrollment,
    billingunenrollmentsearchAPI } = ThriveSignatureRequests();
    const { dispatch, state } = useContext(context);
    const [open, setOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [logData, setLogData] = useState([]);
    const locale = i18n.language == 'fr' ? fr : enUS;
    const [billingDates, setBillingDates] = useState({});
    const [savingId, setSavingId] = useState(null);

    // Table Pagination Func
    const handlePagination = (value) => {
        setOffset(value);
    };


    const [states, setStates] = useState({
        historyLoader: false,
        clearSearch: false,
        status: "",
        plan: "",
        filter: false
    });

    const searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    useEffect(() => {
        // Optional: update pathname globally
        // dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'RESPONSE'] });
        handleGet();
    }, []);

    useEffect(() => {
        if (states?.clearSearch) {
            setStates((prev) => ({ ...prev, clearSearch: false }));
            return;
        }

        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        } else {
            handleGet();
        }
    }, [searchBounceValues, offset, states?.filter]);

    const getPlanName = (plan) => {
        if (!plan) return "-";
        if (plan == 'ST0') return "Monthly";
        if (plan == "ST1") return "Yearly";
        if (plan == "ST2") return "Trial";
        if (plan == "Unlocked") return "Unlocked";
        return "-"
    }

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            const res = await getbillingunenrollmentrecord(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10
            };
            const res = await billingunenrollmentsearchAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveBillingDate = async (row) => {
           const selectedDate =
            billingDates[row.id] || new Date();

            //   const selectedDate =
            // billingDates[row.id] ;
    
    
        // if (!selectedDate) {
        //       return toast.error('Please select the date');
        //     return;
        // }
    
        try {
            setSavingId(row.id);
    
            const payload = {
                id: row.id,
                shipto: row.shipto,
                billingDate: moment(selectedDate).format("YYYY-MM-DD"),
            };
    
            const res = await billingdateunenrollment(payload);
    
            if (res?.result_status === "1") {
                 handleGet();
            return toast.success(res.message);
    
         }
        } catch (e) {
            console.error("Save billing date error:", e);
             handleGet();
             
        } finally {
             handleGet();
             
            setSavingId(null);
        }
    };

    return (
        <>
            <CssTextField
                id="enterPassword"
                placeholder={'Search for Shipto'}
                onKeyDown={blockInvalidChar}
                type={"number"}
              onWheel={(e) => e.target.blur()}
                variant="outlined"
                autoComplete="off"
                className={classes.searchInput}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {searchValue.length > 0 ? (
                                <CloseOutlinedIcon
                                    className={classes.searchInputIcon}
                                    onClick={() => {
                                        setSearchValue("");
                                        setOffset(1);
                                        handleGet()
                                    }}
                                />
                            ) : (
                                <img
                                    src={searchIcon}
                                    alt=""
                                    width="20px"
                                    className={classes.searchInputIcon}
                                />
                            )}
                        </InputAdornment>
                    ),
                }}
                value={searchValue}
                onChange={(e) => {
                    e.target.value.replace(/\s+/g, "").length == 0
                        ? setSearchValue("")
                        : setSearchValue(e.target.value);
                    if (e.target.value.length == 0) {
                        handleGet()
                    }
                }}
                onClick={() => {
                    setOffset(1);
                }}
            />
            <Loader loading={state?.loading} top='15%'>
                <Grid className={classes.tableDownInResponsive}>
                    <Grid item xs={12}>
                        {loading ? (
                            <div
                                style={{
                                    height: "25vh",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <h2>{t('Loading...')}</h2>
                            </div>
                        ) : (
                            <Table
                                headings={['Shipto', 'AccountName', 'City', 'Plan',  'RequestDate','status' ,'SetDate']}
                                data={
                                    data?.map((d, i) => [
                                        d?.shipto,
                                        d?.account_name,
                                        d?.city,
                                        // d?.email,
                                        <span>{getPlanName(d?.privilege_code)}</span>,
                                        // d?.segment_code || '-',
                                        moment(d?.request_date).format('MM-DD-YYYY'),
                                        <div style={d?.status == "Inprogress" ? { color: 'orange' } : { color: 'green' }}>{d?.status}</div>,
                                                                    <div
                                                                     style={{
                                                                         display: "flex",
                                                                         alignItems: "center",
                                                                         gap: "8px",
                                                                     }}
                                                                 >
                                                                     <MuiPickersUtilsProvider
                                                                         utils={DateFnsUtils}
                                                                         locale={locale}
                                                                     >
                                                                         <KeyboardDatePicker
                                                                             disableToolbar
                                                                             name="billingDate"
                                                                             inputVariant="outlined"
                                                                             format={
                                                                                 i18n.language === "en"
                                                                                     ? "MM/dd/yyyy"
                                                                                     : "dd/MM/yyyy"
                                                                             }
                                                                             margin="normal"
                                                                             id={`billing-date-picker-${d?.id}`}
                                                                             style={{
                                                                                 width: "190px",
                                                                                 margin: "0px",
                                                                             }}
                                                                            value={billingDates[d?.id] ||new Date()}
                                                                            //   value={null}
                                                                             minDate={d?.request_date}
                                                                              maxDate={new Date()}
                                                                            onChange={(date) => {
                                                                                 setBillingDates(prev => ({
                                                                                     ...prev,
                                                                                     [d.id]: date
                                                                                 }));
                                                                             }}
                                                                             autoOk
                                                                         />
                                                                     </MuiPickersUtilsProvider>
                                 
                                                                     <Button style ={{background:"#0a72ba",color:"white"}}
                                                                         variant="contained"
                                                                         size="small"
                                                                         // disabled={
                                                                         //     !billingDates[d?.id] ||
                                                                         //     savingId === d?.id
                                                                         // }
                                                                         onClick={() => handleSaveBillingDate(d)}
                                                                     >
                                                                         {savingId === d?.id ? "Saving..." : "Save"}
                                                                     </Button>
                                                                 </div>       
                                        
                                    ])
                                }
                                offset={offset}
                                count={
                                    (count / 10) % 1 == 0
                                        ? Math.floor(count / 10)
                                        : Math.floor(count / 10 + 1)
                                }
                                handlePagination={handlePagination}
                            />
                        )}
                    </Grid>
                </Grid>
            </Loader>
        </>
    )
}

function AddOnPlanRequests({ dialogObj, setDialogObj }) {
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [fitervalue, setfiterValue] = useState("");
    const [response, setResponse] = useState({
        filter: false,
    });
    const [filterCard, setFilterCard] = useState(false);
    const classes = Styles();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [resLoaded, setResLoaded] = useState(false);
    const { t, i18n } = useTranslation();

    const { getaddplanunenrollrecord,
    addplanenrollmentunenrollsearchAPI,
    billingunenrollmentsearchAPI,addOnPlansRemover } = ThriveSignatureRequests();
    const { dispatch, state } = useContext(context);
    const [open, setOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [logData, setLogData] = useState([]);
    const locale = i18n.language == 'fr' ? fr : enUS;
    const [billingDates, setBillingDates] = useState({});
    const [savingId, setSavingId] = useState(null);
    const [salesPlan, setSalesPlan] = useState({});
    const [freeFreight, setFreeFreight] = useState({});
    const [paymentDate, setPaymentDate] = useState({});

    // Table Pagination Func
    const handlePagination = (value) => {
        setOffset(value);
    };


    const [states, setStates] = useState({
        historyLoader: false,
        clearSearch: false,
        status: "",
        plan: "",
        filter: false
    });

    const searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    useEffect(() => {
        // Optional: update pathname globally
        // dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'RESPONSE'] });
        handleGet();
    }, []);

    useEffect(() => {
        if (states?.clearSearch) {
            setStates((prev) => ({ ...prev, clearSearch: false }));
            return;
        }

        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        } else {
            handleGet();
        }
    }, [searchBounceValues, offset, states?.filter]);

    const getPlanName = (plan) => {
        if (!plan) return "-";
        if (plan == 'ST0') return "Monthly";
        if (plan == "ST1") return "Yearly";
        if (plan == "ST2") return "Trial";
        if (plan == "Unlocked") return "Unlocked";
        return "-"
    }

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            const res = await getaddplanunenrollrecord(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10
            };
            const res = await addplanenrollmentunenrollsearchAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleAddonPlans = async (d) => {
    try {
        setSavingId(d?.id);

        const payload = {
            requestId: d?.id,

            salesPlan:
                salesPlan[d?.id] ||
                (d?.sales_plan === 'Apply'
                    ? 'Remove'
                    : 'Not Applicable'),

            freeFreight:
                freeFreight[d?.id] ||
                (d?.free_freight === 'Apply'
                    ? 'Remove'
                    : 'Not Applicable'),

            shipto: d?.shipto,
             paymentDate: paymentDate[d?.id] || moment().format("YYYY-MM-DD")
        };

        console.log("Save payload:", payload);

        const res = await addOnPlansRemover(payload);

        if (res) {
            toast.success("Add-on Plans saved successfully.");
            handleGet();
        }
    } catch (e) {
        console.error("API error:", e);
        toast.error("An error occurred while submitting Add-on Plans.");
    } finally {
        setSavingId(null);
    }
};

    const getAddonOption = (value) => {
    return value === 'Apply' ? 'Remove' : 'Not Applicable';
};

    return (
        <>
            <CssTextField
                id="enterPassword"
                placeholder={'Search for Shipto'}
                onKeyDown={blockInvalidChar}
                type={"number"}
              onWheel={(e) => e.target.blur()}
                variant="outlined"
                autoComplete="off"
                className={classes.searchInput}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {searchValue.length > 0 ? (
                                <CloseOutlinedIcon
                                    className={classes.searchInputIcon}
                                    onClick={() => {
                                        setSearchValue("");
                                        setOffset(1);
                                        handleGet()
                                    }}
                                />
                            ) : (
                                <img
                                    src={searchIcon}
                                    alt=""
                                    width="20px"
                                    className={classes.searchInputIcon}
                                />
                            )}
                        </InputAdornment>
                    ),
                }}
                value={searchValue}
                onChange={(e) => {
                    e.target.value.replace(/\s+/g, "").length == 0
                        ? setSearchValue("")
                        : setSearchValue(e.target.value);
                    if (e.target.value.length == 0) {
                        handleGet()
                    }
                }}
                onClick={() => {
                    setOffset(1);
                }}
            />
            <Loader loading={state?.loading} top='15%'>
                <Grid className={classes.tableDownInResponsive}>
                    <Grid item xs={12}>
                        {loading ? (
                            <div
                                style={{
                                    height: "25vh",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <h2>{t('Loading...')}</h2>
                            </div>
                        ) : (
                                                                <Table
                                        headings={[
                                            'Shipto',
                                            'AccountName',
                                            'City',
                                            'Plan',
                                            'RequestDate',
                                            'status',
                                            'EndDate',
                                            'SalesPlan',
                                            'FF/Surcharge',
                                            'Action'
                                        ]}
                                        data={
                                            data?.map((d, i) => [
                                                d?.shipto,
                                                d?.account_name,
                                                d?.city,

                                                <span>
                                                    {getPlanName(d?.privilege_code)}
                                                </span>,

                                                // d?.segment_code || '-',

                                                moment(d?.request_date).format('MM-DD-YYYY'),
                                                 <div style={d?.status == "Inprogress" ? { color: 'orange' } : { color: 'green' }}>{d?.status}</div>,
                                                  
                                                 

                                              
                                                <MuiPickersUtilsProvider
                                                    utils={DateFnsUtils}
                                                    locale={locale}
                                                   
                                                >
                                                    <KeyboardDatePicker
                                                        disableToolbar
                                                        inputVariant="outlined"
                                                         style={{width:"172px"}}
                                                        format={
                                                            i18n.language === "en"
                                                                ? "MM/dd/yyyy"
                                                                : "dd/MM/yyyy"
                                                        }
                                                        margin="normal"
                                                        label={
                                                            getPlanName(d?.privilege_code) === "Unlocked"
                                                                ? "Unlock End Date"
                                                                : "Signature End Date"
                                                        }
                                                        value={
                                                                    paymentDate[d?.id]
                                                                    ? new Date(paymentDate[d?.id])
                                                                    : d?.signature_end_date
                                                                    ? new Date(d.signature_end_date)
                                                                    : new Date()
                                                                    }
                                                                    minDate={
                                                                    d?.signature_end_date
                                                                    ? new Date(d.signature_end_date)
                                                                    : new Date()
                                                                    }
                                                                    maxDate={
                                                                    d?.signature_end_date
                                                                    ? new Date(d.signature_end_date)
                                                                    : undefined
                                                                    }
                                                        onChange={date => {
                                                            if (date && moment(date).isValid()) {
                                                                setPaymentDate(prev => ({
                                                                    ...prev,
                                                                    [d?.id]: moment(date).format("YYYY-MM-DD")
                                                                }));
                                                            }
                                                        }}
                                                        KeyboardButtonProps={{
                                                            "aria-label": "change date",
                                                        }}
                                                        autoOk
                                                        fullWidth
                                                    />
                                                </MuiPickersUtilsProvider>,
                                                

                                                // Sales Plan
                                                       <div>
                                                    {[getAddonOption(d?.sales_plan)].map(v => (
                                                        <label
                                                            key={v}
                                                            style={{
                                                                display: 'block',
                                                                marginBottom: '4px',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            <input
                                                                type="radio"
                                                                name={`salesPlan-${d?.id}`}
                                                                value={v}
                                                                checked={
                                                                    (salesPlan[d?.id] || getAddonOption(d?.sales_plan)) === v
                                                                }
                                                                onChange={() => {
                                                                    setSalesPlan(prev => ({
                                                                        ...prev,
                                                                        [d?.id]: v
                                                                    }));
                                                                }}
                                                            />
                                                            {' '}{v}
                                                        </label>
                                                    ))}
                                                </div>,
                                                // FF / Surcharge
                                                                                           <div>
                                                            {[getAddonOption(d?.free_freight)].map(v => (
                                                                <label
                                                                    key={v}
                                                                    style={{
                                                                        display: 'block',
                                                                        marginBottom: '4px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name={`freeFreight-${d?.id}`}
                                                                        value={v}
                                                                        checked={
                                                                            (freeFreight[d?.id] || getAddonOption(d?.free_freight)) === v
                                                                        }
                                                                        onChange={() => {
                                                                            setFreeFreight(prev => ({
                                                                                ...prev,
                                                                                [d?.id]: v
                                                                            }));
                                                                        }}
                                                                    />
                                                                    {' '}{v}
                                                                </label>
                                                            ))}
                                                        </div>,
                                                // Save
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    style={{
                                                        background: "#0a72ba",
                                                        color: "white"
                                                    }}
                                                     onClick={() => handleAddonPlans(d)}
                                                >
                                                    {savingId === d?.id ? "Saving..." : "Save"}
                                                </Button>
                                            ])
                                        }
                                        offset={offset}
                                        count={
                                            (count / 10) % 1 == 0
                                                ? Math.floor(count / 10)
                                                : Math.floor(count / 10 + 1)
                                        }
                                        handlePagination={handlePagination}
                                    />
                        )}
                    </Grid>
                </Grid>
            </Loader>
        </>
    )
}


export default function SignatureUnenrollments() {
    const [value, setValue] = useState(1);
    const [data, setData] = useState([]);
    const [reasonData, setReasonData] = useState([]);


    const classes = Styles();
    const i18n = useTranslation();
    const locale = i18n.language == 'fr' ? fr : enUS;
    const { createUnenrollmentReqAPI, getsignatureUnenrollmentReason , getsignatureshipto, } = ThriveSignatureRequests();
    const [dialogObj, setDialogObj] = useState({
        open: false,
        obj: {},
        index: null,
    });
    const { t } = useTranslation();
    const reasonDropDown = [
        { value: 'Closed/Retired/Sold/Collections' },
        { value: 'No reason given' },
        { value: 'No longer working with HS' },
        { value: 'Other' },
        { value: 'Lack of value' },
        { value: 'GPO Enrollment' },
        { value: 'Did not approve enrollment' },
        { value: 'Signature to Accelerate' },
        { value: 'Momentum' },
        { value: 'Intended Thrive Rewards' },
        { value: 'Accelerate - Requested' },
        { value: 'Accelerate - Below 3k' },
        { value: 'Accelerate - Below $3k' },
        { value: 'Moved to DSO' },
        { value: 'Office Closed' },
        { value: 'Trial Cancellation' }
    ]
    const [readOnlyDialogObj, setReadOnlyDialogObj] = useState({
        open: false,
        obj: {},
        index: null,
    });
    const [createDialogObj, setCreateDialogObj] = useState({
        open: false,
        obj: {},
        index: null,
    });
    const [createFormValues, setCreateFormValues] = useState({
        shipto: '',
        unEnrollmentDate: moment().format('YYYY-MM-DD'),
        email: '',
        reason: '',
        notes: '',
        btnLoading: false
    });
    const [formErrors, setFormErrors] = useState({});

    const [creditAvailable, setCreditAvailable] = useState(false);
const [creditLoading, setCreditLoading] = useState(false);

const [credit, setCredit] = useState("");
const [creditApplied, setCreditApplied] = useState("");
const [creditValue, setCreditValue] = useState("");

    useEffect(() => {
        handleGetRole();
    }, []);

    const handleGetRole = async () => {
        try {
            const res = await getsignatureUnenrollmentReason();
            if (res) {
                setData(res)
                setReasonData(res.reason)
                if (res?.team == 'signature') {
                    setValue(0)
                }
            }
        } catch (e) {
            console.error('Get error:', e);
        }
    };


//     const handleShiptoChange = (value) => {
//     setShipto(value);

//     // Reset previous credit details when Shipto changes
//     setCreditAvailable(false);
//     setCredit("");
//     setCreditApplied("");
//     setCreditValue("");
// };

const shiptoTimeout = useRef(null);

const handleShiptoChange = (e) => {
    const { value } = e.target;

    // Existing form change handler
    handleCreateChange(e);

    // Reset credit fields
    setCreditAvailable(false);
    setCredit("");
    setCreditApplied("");
    setCreditValue("");

    clearTimeout(shiptoTimeout.current);

    if (!value) return;

    shiptoTimeout.current = setTimeout(async () => {
        try {
            const res = await getsignatureshipto({
                shipto: value,
            });

            setCreditAvailable(!!res?.data);
        } catch (error) {
            console.error("Error fetching affiliation:", error);
            setCreditAvailable(false);
        }
    }, 500);
};

console.log(creditAvailable,"creditAvailable")


const formatUSNumber = (value) => {
    if (!value) return "";

    const parts = value.split(".");

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return parts.join(".");
};

    const handleCreateChange = (e) => {
        const { id, value, name } = e.target;

        setCreateFormValues((prev) => ({
            ...prev,
            [name]: value
        }));
        // Live validation as user types
        validateField(name, value);
    };

    const validateField = (field, value) => {
        let error = '';

        switch (field) {
            case 'shipto':
                if (!value) error = 'Shipto is required';
                break;

            // case 'email':
            //     if (!value) error = 'Email is required';
            //     else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
            //         error = 'Enter a valid email';
            //     break;

            case 'reason':
                if (!value) error = 'Reason is required';
                break;

            // case 'cancellationDate':
            //     if (!value) error = 'Cancellation date is required';
            //     break;

            default:
                break;
        }

        setFormErrors((prev) => ({
            ...prev,
            [field]: error
        }));

        return error;
    };

    const validateForm = () => {
        const errors = {};

        Object.entries(createFormValues).forEach(([key, value]) => {
            const error = validateField(key, value);
            if (error) errors[key] = error;
        });

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const handleCreateSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        if(!createFormValues.notes){
            toast.error("Please Provide  the cancellation notes");
            return;
        }

          if (creditAvailable && !credit) {
    toast.error("Please Provide the Credit YES or NO");
    return;
}

         if (creditAvailable && credit === "Yes" && !creditValue) {
    toast.error("Please Provide the Credit Value");
    return;
}
        setCreateFormValues({...createFormValues, btnLoading: true});

                        const payload = {
                    ...createFormValues,
                    credit: credit || null,
                    credit_applied: creditApplied || null,
                    credit_value:
                        credit === "Yes" && creditValue !== ""
                            ? Number(creditValue.replace(/,/g, ""))
                            : null,
                };
        try {
            const res = await createUnenrollmentReqAPI(payload);
            // 🧩 If backend sent success: true
            if (res?.success) {
                toast.success(res?.message || "Unenrollment request created successfully", { toastId: "unenrollment-request" });
                setCreateDialogObj({ ...createDialogObj, open: false });  
                setCreateFormValues({
                    shipto: '',
                    unEnrollmentDate: moment().format('YYYY-MM-DD'),
                    email: '',
                    reason: '',
                    notes: '',
                    btnLoading: false,
                     
                });
                  setCreditAvailable(false)
                              setCredit("")
                                setCreditApplied("")
                                setCreditValue("")
                              
                setFormErrors({});                
            } else {
                toast.error(res.message || "Submission failed. Please try again.", { toastId: "unenrollment-request" });
                setCreateFormValues({ ...createFormValues, btnLoading: false });        
            }  
             
        } catch (error) {
            console.error("API error:", error);
            toast.error("API error. Please try again later.", { toastId: "unenrollment-request" });
            setCreateFormValues({ ...createFormValues, btnLoading: false });
        }
    };


    const components = [
        <AllRequests setReadOnlyDialogObj={setReadOnlyDialogObj} setCreateDialogObj={setCreateDialogObj} team={data?.team} />,
        <PendingRequests dialogObj={dialogObj} setDialogObj={setDialogObj} />,
        <BillingRequests/>,
        <AddOnPlanRequests/>
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const invalidChar = [
        '~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';',
        ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'",'@','&','/','-',
      
        // numbers added
        '0','1','2','3','4','5','6','7','8','9'
      ];
  const blockInvalidCharcancel = e => invalidChar.includes(e.key) && e.preventDefault();

    return (
        <>
            <Box>
                <Tabs value={value} onChange={handleChange} aria-label="Points Management Tabs"
                    TabIndicatorProps={{
                        style: { backgroundColor: '#007bff' }, // e.g., '#1976d2' for blue
                    }}>
                    <Tab label="All Requests" />
                    {data?.team != 'signature' && <Tab label="My Pending Requests" />}
                    <Tab label="Billing Date Setting"/>
                    <Tab label="Add On Plan Setting"/>
                </Tabs>
                <Box sx={{ p: 2 }}>
                    {components[value]}
                </Box>
            </Box>
            <Dialog
                open={dialogObj?.open}
                onClose={() => setDialogObj({ open: false, obj: {}, index: null })}
                maxWidth={false}
                PaperProps={{
                    style: {
                        width: "500px",
                        borderRadius: "12px",
                        fontFamily: "Segoe UI"
                    }
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={() => setDialogObj({ open: false, obj: {}, index: null })}
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#888'
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <div
  style={{
    fontSize: 16,
    fontWeight: 600,
    margin: "10px 0px 0px 20px",
    padding: "2px 10px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    background: "grey",
    color: "#fff",
    display: "flex",
    width: "141px"
   
  }}
>
{
  ['yearly', 'monthly', 'trial'].some(item =>
    String(dialogObj?.obj?.plan).toLowerCase().includes(item)
  )
    ? 'Thrive Signature'
    : 'Thrive Unlocked'
}
</div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ fontSize: 16, fontWeight: 600, margin: "10px 0px 0px 20px", padding: "2px 10px", border: "1px solid #ddd", borderRadius: "5px", background: "grey", color: "#fff" }}>Shipto: {dialogObj?.obj?.shipto}</div>
                </div>

                <div style={{ padding: 20 }}>
                    <VerticalLinearStepper activeStep={dialogObj?.obj?.activeStep} setDialogObj={setDialogObj} requestId={dialogObj?.obj?.requestId} shipto={dialogObj?.obj?.shipto} handleGet={dialogObj?.obj?.handleGet} plan={dialogObj?.obj?.plan} type="unenrollment" />
                </div>
            </Dialog>

            <Dialog
                open={readOnlyDialogObj?.open}
                onClose={() => setReadOnlyDialogObj({ open: false, obj: {}, index: null })}
                maxWidth={false}
                PaperProps={{
                    style: {
                        width: "73%",
                        borderRadius: "12px",
                        fontFamily: "Segoe UI",
                        height: "100vh",
                        background: "rgb(245,245,245)"
                    }
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={() => setReadOnlyDialogObj({ open: false, obj: {}, index: null })}
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#888'
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <div
  style={{
    fontSize: 16,
    fontWeight: 600,
    margin: "10px 0px 0px 20px",
    padding: "2px 10px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    background: "grey",
    color: "#fff",
    display: "flex",
    width: "141px"
   
  }}
>
{
  ['yearly', 'monthly', 'trial'].some(item =>
    String(readOnlyDialogObj?.obj?.planType).toLowerCase().includes(item)
  )
    ? 'Thrive Signature'
    : 'Thrive Unlocked'
}
</div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ fontSize: 16, fontWeight: 600, margin: "10px 0px 0px 20px", padding: "2px 10px", border: "1px solid #ddd", borderRadius: "5px", background: "grey", color: "#fff" }}>Shipto: {readOnlyDialogObj?.obj?.shipto}</div>
                </div>
                <div style={{ padding: 20 }}>
                    <HorizontalStepperForUnenrollment activeStep={readOnlyDialogObj?.obj?.activeStep} requestId={readOnlyDialogObj?.obj?.requestId } plan={readOnlyDialogObj?.obj?.planType} />
                </div>
            </Dialog>

            <Dialog
                open={createDialogObj?.open}
                keepMounted
                onClose={() => setCreateDialogObj({ ...createDialogObj, open: false })}
                aria-describedby='alert-dialog-slide-description'
                fullWidth
                maxWidth='xs'
                disableBackdropClick
            >
                <DialogContent>
                    <CloseOutlinedIcon
                        className={classes.closeIcon}
                        onClick={() => {
                            setCreateDialogObj({ ...createDialogObj, open: false });
                            setCreateFormValues({
                                shipto: '',
                                unEnrollmentDate: moment().format('YYYY-MM-DD'),
                                email: '',
                                reason: '',
                                notes: '',
                                btnLoading: false,
                               

                            });
                            setFormErrors({});
                             setCreditAvailable(false)
                              setCredit("")
                                setCreditApplied("")
                                setCreditValue("")
                        }}

                        
                    />
                    <div
                        style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            textAlign: 'center',
                            margin: "15px 0px",
                        }}
                    >
                        {'Create New Unenrollment Request'}
                    </div>
                    <DialogContentText id='alert-dialog-slide-description'>
                        <Grid
                            container
                            item
                            xs={12}
                            spacing={2}
                        >
                            <Grid item xs={12}>
                                <CssTextField
                                    id='shipto'
                                    name='shipto'
                                    label={
                                        <span>
                                            {t('Shipto')} <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    type={"number"}
              onWheel={(e) => e.target.blur()}
                                    fullWidth
                                    value={createFormValues.shipto}
                                    onKeyDown={blockInvalidChar}
                                    // onChange={handleCreateChange}
                                     onChange={handleShiptoChange}
                                    error={!!formErrors.shipto}
                                    helperText={formErrors.shipto}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CssTextField
                                    select
                                    id='reason'
                                    name='reason'
                                    label={
                                        <span>
                                            {t('Reason')} <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    type='select'
                                    fullWidth
                                    value={createFormValues.reason}
                                    onChange={handleCreateChange}
                                    error={!!formErrors.reason}
                                    helperText={formErrors.reason}
                                >
                                    {reasonData &&
                                        reasonData.length > 0 &&
                                        reasonData?.map((r, i) => (
                                            <MenuItem
                                                value={r.reason_description}
                                                key={i}
                                                style={{
                                                    backgroundColor:
                                                      (r.reason_description && r.reason_description?.toLowerCase() === 'others' )? '#a9d3f5' : '',
                                                    color: (r.reason_description && r.reason_description?.toLowerCase() === 'others' )? 'black' : ''
                                                }}
                                            >
                                                {r.reason_description}
                                            </MenuItem>
                                        ))
                                    }
                                </CssTextField>
                            </Grid>
                            <Grid item xs={12}>
                                <CssTextField
                                    id='notes'
                                    name='notes'
                                    label={
                                        <span>
                                            {t('Cancellation Notes')} <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    type='textarea'
                                    fullWidth
                                    value={createFormValues.notes}
                                    onChange={handleCreateChange}
                                    error={!!formErrors.notes}
                                    helperText={formErrors.notes}
                                    onKeyDown={blockInvalidCharcancel}
                                />
                            </Grid>

                              {creditAvailable && (
    <Grid item xs={12}>
        <CssTextField
            select
            // label="Credit"

              label={
                    <span>
                    {t('Credit')} <span style={{ color: 'red' }}>*</span>
                    </span>
                                    }
            name="credit"
            value={credit}
            onChange={(e) => {
                setCredit(e.target.value);
                setCreditApplied("");
                setCreditValue("");
            }}
            fullWidth
        >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
        </CssTextField>
    </Grid>
)}

    {/* Credit Value - Only Yes */}
   {creditAvailable && credit === "Yes" && (
    <Grid item xs={12}>
        <CssTextField
            // label="Credit Value ($)"

             label={
                    <span>
                    {t('Credit Value ($)')} <span style={{ color: 'red' }}>*</span>
                    </span>
                                    }
            name="creditValue"
            value={formatUSNumber(creditValue)}
            onChange={(e) => {
                const value = e.target.value.replace(/,/g, "");

                if (/^\d*\.?\d{0,2}$/.test(value)) {
                    setCreditValue(value);
                }
            }}
            fullWidth
            type="text"
            inputProps={{ inputMode: "decimal" }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                ),
            }}
        />
    </Grid>
)}

    {/* Credit Applied - Normal Text Field */}
    {creditAvailable && credit !== "" && (
        <Grid item xs={12}>
            <CssTextField
                // label="Credit Applied"
                 label={
                    <span>
                    {t('Credit Applied Comments')} 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </span>
                                    }
                name="creditApplied"
                value={creditApplied}
                onChange={(e) => setCreditApplied(e.target.value)}
                fullWidth
            />
        </Grid>
    )}


                        </Grid>
                        <div className={classes.popupBtnDiv}>
                            <button className={classes.submitBtn} onClick={handleCreateSubmit} disabled={createFormValues?.btnLoading}>
                                {createFormValues?.btnLoading ? 'Loading...' : 'Submit'}
                            </button>
                        </div>

                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <style>
                {`
                    .tabs {
                    background: #fff;
                    border-radius: 12px;
                    padding: 20px;
                    box-shadow: 0 4px 14px rgba(0,0,0,0.08);
                    width: 100%;
                    max-width: 900px;
                    margin: 20px auto;
                    font-family: Arial, sans-serif;
                    }
                    .tab-labels {
                    display: flex;
                    gap: 10px;
                    margin-bottom: 16px;
                    }
                    .tab-labels button {
                    padding: 10px 16px;
                    border: none;
                    border-radius: 8px;
                    background: #f0f0f0;
                    cursor: pointer;
                    font-weight: 600;
                    color: #555;
                    }
                    .tab-labels button.active {
                    background: #7c5cff;
                    color: #fff;
                    }
                    .panel {
                    padding: 10px;
                    background: #fafafa;
                    border-radius: 8px;
                    }
                    table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 10px;
                    }
                    th, td {
                    padding: 10px;
                    border-bottom: 1px solid #ddd;
                    text-align: left;
                    }
                    th {
                    background: #f5f5f5;
                    font-weight: 600;
                    }
                    .status {
                    padding: 4px 10px;
                    border-radius: 6px;
                    font-size: 0.85rem;
                    font-weight: 600;
                    color: #fff;
                    }
                    .status.active {
                    background: #28a745;
                    }
                    .status.pending {
                    background: #ffc107;
                    color: #000;
                    }
                    .action-btn {
                    padding: 6px 12px;
                    border: none;
                    border-radius: 6px;
                    background: #007bff;
                    color: #fff;
                    cursor: pointer;
                    }
                `}
            </style>
        </>
    );
}